import React, { useState, useEffect, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';
import { X, Plus } from 'react-bootstrap-icons';
import { normalizeId } from '../helpers/utility';

const TagsInput = ({
  id,
  title,
  preValue = [],
  onFormChange,
  placeholder = 'Enter text...',
  inputType = 'text',
  disabled = false,
  size = 'md'
}) => {
  const [tags, setTags] = useState(preValue || []);
  const [inputValue, setInputValue] = useState('');
  const onFormChangeRef = useRef(onFormChange);

  const inputId = id || normalizeId(title);

  useEffect(() => {
    onFormChangeRef.current = onFormChange;
  }, [onFormChange]);

  useEffect(() => {
    // Update the hidden input when tags change
    const hiddenInput = document.getElementById(`${inputId}-tags`);
    if (hiddenInput) {
      hiddenInput.value = JSON.stringify(tags);
    }

    // Trigger form change
    if (onFormChangeRef.current) {
      const event = {
        target: {
          id: inputId,
          value: JSON.stringify(tags)
        }
      };
      onFormChangeRef.current(event);
    }
  }, [tags, inputId]);

  const handleAddTag = () => {
    if (!inputValue.trim()) return;

    // Check if tag already exists
    if (tags.includes(inputValue.trim())) {
      return;
    }

    setTags([...tags, inputValue.trim()]);
    setInputValue('');
  };

  const handleRemoveTag = tagToRemove => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <>
      <Form.Group className="m-0 p-0" style={{ height: 'auto' }}>
        <div className="d-flex flex-wrap">
          {tags.map(tag => (
            <div
              key={tag}
              className="d-flex align-items-center bg-secondary text-white rounded-pill px-3 py-1 mr-1 mb-2"
            >
              <span style={{ fontSize: '12px' }}>{tag}</span>
              <Button
                variant="link"
                onClick={() => handleRemoveTag(tag)}
                className="p-0 ms-2"
                style={{ color: 'white', lineHeight: 1 }}
                disabled={disabled}
              >
                <X size={15} />
              </Button>
            </div>
          ))}
        </div>
        <div className="d-flex">
          <Form.Control
            type={inputType}
            placeholder={placeholder}
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            size={size}
          />
          <Button
            variant="outline-secondary"
            className="d-flex align-items-center ml-2"
            onClick={handleAddTag}
            disabled={disabled}
          >
            <Plus size={16} className="me-1" />
          </Button>
        </div>
        <p className="text-muted small mt-1 ml-2 mb-0">Press Enter to Add {title}</p>
        {/* Hidden input to store tags data for form submission */}
        <input type="hidden" id={`${inputId}-tags`} value={JSON.stringify(tags)} />
      </Form.Group>
    </>
  );
};

export default TagsInput;
